<section class="text-white secondary-header">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h1 class="text-center">Timetable</h1>
            </div>
        </div>
    </div>
</section>



<div style="margin-top: 50px" class="container ">
    <div class="row">
        <div class="col-md-3 col-sm-6">
            <h5>Institute</h5>
            <div class="px-5 shadow-xs course-dropdown">
                <mat-select class="py-4" [(ngModel)]="selectedCourse">
                    <ng-container *ngFor="let course of courses">
                        <mat-option *ngIf="course.Cms?.id" [value]="course"
                            (onSelectionChange)="coursesChanged($event)">
                            {{ course.Cms?.short_title }}
                        </mat-option>
                    </ng-container>

                </mat-select>
            </div>
        </div>

        <div class="col-md-3 col-sm-6">
            <h5 class="t-t-header">Region</h5>
            <div class="px-5 shadow-xs course-dropdown">
                <mat-select class="py-4" [(ngModel)]="selectedRegion">
                    <mat-option *ngFor="let region of regions" [value]="region"
                        (onSelectionChange)="regionsChanged($event)">
                        {{ region.RegionName._text }}
                    </mat-option>
                </mat-select>
            </div>
        </div>

        <div class="col-md-3 col-sm-6">
            <h5 class="t-t-header">Level</h5>
            <div class="px-5 shadow-xs course-dropdown">
                <mat-select class="py-4" [(ngModel)]="selectedLevel">
                    <mat-option value="default" (onSelectionChange)="levelsChanged($event)">
                        All Levels
                    </mat-option>
                    <mat-option *ngFor="let level of levels; index as i;" [value]="level"
                        (onSelectionChange)="levelsChanged($event)">
                        {{ level?.SubjectLevelName?._text }}
                    </mat-option>
                </mat-select>
            </div>
        </div>

        <div class="col-md-3 col-sm-6">
            <h5 class="t-t-header">Subject</h5>
            <div class="px-5 shadow-xs course-dropdown">
                <mat-select class="py-4" [(ngModel)]="selectedSubject">
                    <mat-option value="default" (onSelectionChange)="subjectsChanged($event)">
                        All Subjects
                    </mat-option>
                    <mat-option *ngFor="let subject of subjects" [value]="subject"
                        (onSelectionChange)="subjectsChanged($event)">
                        {{ subject?.title }}
                    </mat-option>
                </mat-select>
            </div>
        </div>

    </div>




    <div style="margin-top: 30px;" class="row mb-60  d-md-block d-lg-block d-xl-block">
        <div class="col-12">

            <ng-container *ngIf="loading">
                <span class="uploader-status">
                    <mat-spinner diameter="24" style="margin:0 auto;">
                    </mat-spinner>
                </span>
            </ng-container>


            <div class="card main-card" *ngIf="!loading && isBrowser">
                <div class="row mb-10">
                    <div class="col-md-4 col-sm-12">
                        <ul class="nav nav-pills nav-fill nav-pay-method">
                            <li class="nav-item cursor-pointer">
                                <span class="nav-link" [class.active]="timetableOrList == 'timetable'"
                                    (click)="timetableOrList = 'timetable'">Timetable</span>
                            </li>
                            <li class="nav-item cursor-pointer">
                                <span class="nav-link" [class.active]="timetableOrList == 'list'"
                                    (click)="timetableOrList = 'list'">List</span>
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-4 col-sm-12"></div>
                    <div class="col-md-4 col-sm-12 mobile-top-space">
                        <ul class="nav nav-pills nav-fill nav-pay-method no-border">
                            <li class="nav-item cursor-pointer">
                                <span class="nav-link" [class.active]="weekday" (click)="toggleWeek()">Weekdays</span>
                            </li>
                            <li class="nav-item cursor-pointer">
                                <span class="nav-link" [class.active]="weekend"
                                    (click)="toggleWeekend()">Weekends</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="row mb-10">
                    <div class="col-12 ">
                        <mat-checkbox style="margin-right: 30px;" [(ngModel)]="sessionFilter" [value]="sessionFilter"
                            (change)="sessionFilterChange($event)" [checked]="true">Classes </mat-checkbox>
                        <mat-checkbox style="margin-right: 30px;" [(ngModel)]="examFilter" [value]="examFilter"
                            (change)="examFilterChange($event)" [checked]="true">Exams </mat-checkbox>
                        <mat-checkbox [(ngModel)]="eventFilter" [value]="eventFilter"
                            (change)="eventFilterChange($event)" [checked]="true">Events </mat-checkbox>
                    </div>
                </div>
                <ng-container *ngIf="calendarOptions?.events.length > 0 ">
                    <!-- THE LIST-->
                    <ng-container *ngIf="timetableOrList == 'list'">
                        <hr style="opacity: 0.5;">
                        <div class="mt-5">
                            <div *ngFor="let evntObj of endEvents">
                                <h5>
                                    {{formatDate(evntObj?.date)}}</h5>
                                <div *ngFor="let evnt of evntObj.items" style="padding-top: 5px;">


                                    <div (mouseleave)="p.close()">
                                        <span type="button" placement="left" (mouseenter)="p.open()" #p="ngbPopover"
                                            [ngbPopover]="popContent" placement="top">

                                            <ng-template #popContent>
                                                <h6 [innerHTML]="evnt.subjectName"></h6>
                                                <br>
                                                <div>
                                                    <p><b>Code</b>: {{evnt.subjectCode}}</p>
                                                    <p><b>Venue:</b> {{evnt.venueName}}</p>
                                                    <p *ngIf="evnt?.subjectLevelName"><b>Level:</b>
                                                        {{evnt?.subjectLevelName}}</p>
                                                    <p><b>Time:</b> {{evnt.time}}</p>
                                                </div>
                                            </ng-template>

                                            <div *ngIf="evnt?.time" style="display: inline-block;  min-width: 30px;">
                                                <b>{{evnt?.subjectCode}}</b>
                                            </div>
                                            <span *ngIf="!evnt?.time">
                                                <b>{{evnt?.subjectCode}} </b>
                                            </span>
                                            <span *ngIf="evnt?.time">
                                                {{evnt?.time}}.
                                            </span>

                                            <b>{{evnt?.subjectName}}</b>
                                        </span>
                                    </div>


                                </div>
                                <hr>

                            </div>
                        </div>

                    </ng-container>
                    <!-- THE CALENDAR-->
                    <ng-container *ngIf="timetableOrList == 'timetable'">
                        <full-calendar *ngIf="!loading" [options]="calendarOptions" deepChangeDetection="true">
                        </full-calendar>
                    </ng-container>

                </ng-container>
                <div *ngIf="!loading && calendarOptions?.events.length == 0 " class="alert alert-danger">
                    No items available for this filter.

                </div>


            </div>


            <ng-template #popoverTmpl let-event="event">
                <h6 [innerHTML]="event.extendedProps.subjectName"></h6>
                <br>
                <div>
                    <p><b>Code</b>: {{event.extendedProps.subjectCode}}</p>
                    <p><b>Venue:</b> {{event.extendedProps.venueName}}</p>
                    <p *ngIf="event.extendedProps.subjectLevelName"><b>Level:</b>
                        {{event.extendedProps.subjectLevelName}}</p>
                    <p><b>Time:</b> {{event.extendedProps.time}}</p>
                </div>
            </ng-template>
        </div>
    </div>


</div>

<section class="bg-white" *ngIf="!loaded">
    <div class="container">
        <div class="row pt-60 study-method d-flex flex-column-reverse flex-sm-column-reverse flex-md-row">
            <div class="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-5">
                <ngx-skeleton-loader count="1" animation="pulse" [theme]="{ 
                    'height': '64px',
                    'width': '64px'
                }"></ngx-skeleton-loader>

                <div style="clear: both;"></div>

                <ngx-skeleton-loader count="1" animation="pulse" [theme]="{ 
                    'height': '30px',
                    'width': '50%'
                }"></ngx-skeleton-loader>

                <ngx-skeleton-loader count="3" animation="pulse" [theme]="{ 
                    'height': '20px',
                    'width': '95%'
                }"></ngx-skeleton-loader>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-7 col-xl-7 d-flex justify-content-md-end mb-10">
                <div style="width: 80%; height: 250px;">
                    <ngx-skeleton-loader count="1" animation="pulse" [theme]="{ 
                    'height': '100%',
                    'width': '100%'
                }"></ngx-skeleton-loader>
                </div>
            </div>
        </div>
    </div>
</section>

<ng-container *ngIf="loaded">

    <ng-container *ngIf="page?.template == 'TIMETABLE'">
        <app-pb-container [content]="content"></app-pb-container>
    </ng-container>

</ng-container>